import React, { useContext, useEffect, useState } from 'react';
import { HashRouter, Routes, Route, Navigate, useLocation, useMatch, useNavigate } from 'react-router-dom';

import Header from '../Common/Header/Header';
import Sidebar from '../Common/Sidebar/Sidebar';
import Footer from '../Common/Footer/Footer';

import AdminDashboard from '../Admin/AdminDashboard';
import MyMeetings from '../Admin/Mettings/MyMeetings/MyMeetings';

import MeetingSummary from '../Admin/Mettings/MeetingSummary/MeetingSummary';
import CalendarIntegration from '../Admin/Mettings/CalendarIntegration/CalendarIntegration';
import SetUpMeeting from '../Admin/Mettings/SetUpMeeting';


import "./main.css";
import ErrorPage from '../ErrorPage/ErrorPage';

import EditPastMeeting from '../Admin/Mettings/MyMeetings/PastMeetings/EditPastMeeting';
import ControlReference from '../Admin/ControlReference';
import { contextData } from '../../context/ContextProvider';
import FailModal from '../Common/Popups/FailModal';


import Audit from '../Admin/Audit/Audit';
import Observations from '../Admin/Audit/Observations';
import { paths } from '../../constants/paths';
import TaskBoard from '../Admin/TaskBoard/TaskBoard';
import AuditCal from '../Admin/Audit/AuditCal';
import TeamManagement from '../Admin/TeamManagement/TeamManagement';
import { Cuurent_USER_ROLES } from '../CommonCase/CommonFunctions';

export const handleLocationUpdate = (location, paths, locationsArr, setOverflowMain, setNextPath) => {
  setOverflowMain(false);

  // Check if 'calendar' is part of the pathname
  if (location.pathname.includes('calendar')) {
    setOverflowMain(true);
  }

  // Set next path based on the last item in locationsArr
  if (paths[`${locationsArr[locationsArr?.length - 1]}`]) {
    setNextPath(paths[`${locationsArr[locationsArr?.length - 1]}`]);
  } else {
    setNextPath('');
  }
};


export const handleBack = ({
  location,
  viewPastMeeting,
  fromPastMeeting,
  setViewPastMeeting,
  setFromPastMeeting,
  navigate,
  setActiveTBbutton,
  NavFromTBoard,
}) => {
  if (location.pathname?.includes('/meetings/my-meetings') && viewPastMeeting?.isView) {
    if (fromPastMeeting === 'past') {
      setViewPastMeeting({ isView: false, meetingId: "" });
    } else if (fromPastMeeting === 'cal') {
      setViewPastMeeting({ isView: false, meetingId: "" });
      setFromPastMeeting(true);
      navigate('/main/meetings/calendar');
    } else if (fromPastMeeting === 'cref') {
      setViewPastMeeting({ isView: false, meetingId: "" });
      setFromPastMeeting(true);
      navigate('/main/control-reference');
    } else if (fromPastMeeting === 'taskboard') {
      setViewPastMeeting({ isView: false, meetingId: "" });
      setFromPastMeeting(true);
      navigate('/main/taskboard');
      setActiveTBbutton(NavFromTBoard === "navFromTaskList" ? 1 : 2);
    }
  } else if (location.pathname?.includes('/meetings/meeting-summary') && viewPastMeeting?.isView) {
    setViewPastMeeting({ isView: false, meetingId: "" });
  } else {
    navigate(-1);
  }
};



export const handleLogout = (navigate, setActive) => {
  sessionStorage.clear();
  navigate('/login');
  setActive('tab1');
};

export const handleCloseFailModel = (setOpenFailModal, setFailMessage, handleLogout) => {
  setOpenFailModal(false);
  setFailMessage("");
  handleLogout();
};

export const handleLogoutWrapped = (navigate, setActive) => {
  handleLogout(navigate, setActive);
};

// Exporting handleCloseFailModelWrapped with parameters
export const handleCloseFailModelWrapped = (setOpenFailModal, setFailMessage, handleLogoutWrapped) => {
  handleCloseFailModel(setOpenFailModal, setFailMessage, handleLogoutWrapped);
};


const Main = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { openFailModal, setOpenFailModal, failMessage, setFailMessage, setActive, viewPastMeeting, setViewPastMeeting, fromPastMeeting, setFromPastMeeting, setActiveTBbutton, ActiveTBbutton, NavFromTBoard, setNavFromTBoard } = useContext(contextData);
  // const { setViewPastMeeting, setLoading, setActive } = useContext(contextData);
  const [overflowMain, setOverflowMain] = useState(false);

  const [showDropdown, setShowDropdown] = useState(false);


  const [nextPath, setnextPath] = useState("")


  // const handleLogoutWrapped = () => handleLogout(navigate, setActive);
  // const handleCloseFailModelWrapped = () => handleCloseFailModel(setOpenFailModal, setFailMessage, handleLogoutWrapped);

  const locationsArr = location?.pathname?.split("/");
  useEffect(() => {
    handleLocationUpdate(location, paths, locationsArr, setOverflowMain, setnextPath);
  }, [location.pathname]);


  useEffect(() => {
    if (sessionStorage.getItem('TOKEN') == null) {
      navigate('/login')
    }
  }, [])

  // const location = useLocation();
  const crtpath = location?.pathname;
  // ---------------------------------------------------------------------------Handle Back------------------------------------------------------

  let roles = Cuurent_USER_ROLES();
  let isOrganizer = roles?.includes("QMS Organizer");
  let isUser = roles?.includes("QMS User");
  let isAuditee = roles?.includes("QMS Auditee");
  let isAuditor = roles?.includes("QMS Auditor");



  return (
    <>
      <div className="main" data-testid="showDropdownmain" onClick={() => { showDropdown && setShowDropdown(false) }}>

        <header className='header'>
          <Header setShowDropdown={setShowDropdown} showDropdown={showDropdown} />
        </header>

        <div className='content-main'>

          {!(((isOrganizer == false && (location.pathname?.includes("/team-management") || location.pathname?.includes('/meetings/setupmeeting'))) || (!(((isAuditor || isAuditee || isOrganizer) && isUser) ||
            ((isAuditor || isAuditee || isOrganizer))) && (location.pathname?.includes("/control-reference") || location.pathname?.includes("audit/observation") || location.pathname?.includes("/audit/checklist") || location.pathname?.includes('/meeting-summary') || location.pathname?.includes("/audit/calendar"))))) && <aside className='aside'>
              <Sidebar />
            </aside>}
          <main className='content' style={{ overflow: overflowMain ? "visible" : "hidden" }}>
            {!(((isOrganizer == false && (location.pathname?.includes("/team-management") || location.pathname?.includes('/meetings/setupmeeting'))) || (!(((isAuditor || isAuditee || isOrganizer) && isUser) ||
              ((isAuditor || isAuditee || isOrganizer))) && (location.pathname?.includes("/control-reference") || location.pathname?.includes("audit/observation") || location.pathname?.includes("/audit/checklist") || location.pathname?.includes('/meeting-summary') || location.pathname?.includes('/meetings/setupmeeting') || location.pathname?.includes("/audit/calendar"))))) &&
              <div className="current-path" >
                {
                  location?.pathname !== "/main" &&
                  <div className="back-button" data-testid="backbuttondiv">
                    {/* <BiArrowBack fill='#00AFF1' size={'15px'} /> */}<span data-testid="handleBackbutton1" onClick={() => handleBack({
                      location,
                      viewPastMeeting,
                      fromPastMeeting,
                      setViewPastMeeting,
                      setFromPastMeeting,
                      navigate,
                      setActiveTBbutton,
                      NavFromTBoard,
                    })}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="38.533px" height="14.828px" viewBox="0 0 37.533 23.828">
                        <g id="Icon_feather-arrow-left" data-name="Icon feather-arrow-left" transform="translate(-6.5 -6.086)">
                          <path id="Path_15928" data-name="Path 15928" d="M43.033,18H7.5" fill="none" stroke="#00aff1" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                          <path id="Path_15929" data-name="Path 15929" d="M18,28.5,7.5,18,18,7.5" fill="none" stroke="#00aff1" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                        </g>
                      </svg>
                    </span>
                  </div>
                }
                {location?.pathname == "/main" && <div></div>}
                <div>

                  {((location.pathname?.includes('/meetings/my-meetings') || location.pathname?.includes('/meetings/meeting-summary') || location.pathname?.includes('/main/meetings/calendar') || location.pathname?.includes("/control-reference")) && viewPastMeeting.isView == false) &&
                    <div className='color-main-cont'>

                      <div className='color-dept-cont' style={{ marginLeft: location.pathname?.includes('/main/meetings/calendar') ? '100px' : '' }}><div className='color-circle' style={{ backgroundColor: '#700098' }}></div>
                        <div style={{ color: '#989898' }}>Hr</div></div>
                      <div className='color-dept-cont' style={{ marginLeft: "15px" }}>
                        <div className='color-circle' style={{ backgroundColor: '#057daa' }}></div>
                        <div style={{ color: '#989898' }}>Governance</div></div>
                      <div className='color-dept-cont' style={{ marginLeft: "15px" }}>
                        <div className='color-circle' style={{ backgroundColor: '#4cb87c' }}></div>
                        <div style={{ color: '#989898' }}>IT</div></div>
                      <div className='color-dept-cont' style={{ marginLeft: "15px" }}>
                        <div className='color-circle' style={{ backgroundColor: '#ff9b00' }}></div>
                        <div style={{ color: '#989898' }}>Facillity</div></div>
                    </div>}
                </div>

                <div className="path">
                  <span>{nextPath !== "" ? nextPath : ""}</span>
                  <span style={{ color: nextPath !== "" && "#B8B8B8" }}>{nextPath !== "" ? ">" : ""}</span>
                  <span style={{ color: nextPath !== "" && "#B8B8B8" }} onClick={() => navigate('/main')}>Dashboard</span>
                </div>
              </div>}
            {
              sessionStorage.getItem("TOKEN") ?
                <Routes>
                  <Route path="/" element={<AdminDashboard />} />
                  <Route path="/meetings/my-meetings" element={<MyMeetings />} />
                  {!(((isAuditor || isAuditee || isOrganizer) && isUser) ||
                    ((isAuditor || isAuditee || isOrganizer))) &&
                    <Route path="/meetings/meeting-summary" element={<ErrorPage />} />}
                  <Route path="/meetings/meeting-summary" element={<MeetingSummary />} />
                  <Route path="/meetings/calendar" element={<CalendarIntegration />} />
                  {
                    !isOrganizer &&
                    <Route path="/meetings/setupmeeting" element={<ErrorPage />} />
                  }
                  <Route path="/meetings/setupmeeting" element={<SetUpMeeting />} />
                  <Route path="/meetings/edit-past-meeting" element={<EditPastMeeting />} />
                  {/* <Route path="/control-reference" element={<ControlReference />} /> */}
                  {!(((isAuditor || isAuditee || isOrganizer) && isUser) ||
                    ((isAuditor || isAuditee || isOrganizer))) &&
                    <Route path="/control-reference" element={<ErrorPage />} />}
                  <Route path="/control-reference" element={<ControlReference />} />
                  {!(((isAuditor || isAuditee) && isUser) ||
                    ((isAuditor || isAuditee || isOrganizer))) &&
                    <Route path="/audit/checklist" element={<ErrorPage />} />}

                  <Route path="/audit/checklist" element={<Audit />} />

                  {!(((isAuditor || isAuditee || isOrganizer) && isUser) ||
                    ((isAuditor || isAuditee || isOrganizer))) &&
                    <Route path="/audit/observation" element={<ErrorPage />} />}

                  <Route path="/audit/observation" element={<Observations />} />

                  {!(((isAuditor || isAuditee || isOrganizer) && isUser) ||
                    ((isAuditor || isAuditee || isOrganizer))) &&
                    <Route path="/audit/calendar" element={<ErrorPage />} />}

                  {<Route path="/audit/calendar" element={<AuditCal />} />}
                  <Route path="/taskboard" element={<TaskBoard />} />
                  {isOrganizer && <Route path="/team-management" element={<TeamManagement />} />}
                  {!isOrganizer && <Route path="/team-management" element={<ErrorPage />} />}
                </Routes>
                :

                <Routes>
                  <Route path="/" element={<AdminDashboard />} />
                  <Route path="/meetings/my-meetings" element={<MyMeetings />} />
                  <Route path="/meetings/meeting-summary" element={<MeetingSummary />} />
                  <Route path="/meetings/calendar" element={<CalendarIntegration />} />
                </Routes>
            }
          </main>
        </div>

        <footer className='footer'>
          <Footer />
        </footer>
        <FailModal
          openFailModal={openFailModal}
          setOpenFailModal={setOpenFailModal}
          failMessage={failMessage}
          setFailMessage={setFailMessage}
          recallFunctionOnOk={handleCloseFailModelWrapped}
          recallFunctiononClose={handleCloseFailModelWrapped}
        />
      </div>
    </>
  )
}


export default Main;


